import Vue from "vue";
import storage from "../libs/SafeStorage";
import bugsnagClient from "@/utilities/bugsnag";

let showValidationErrorTimer = 5000;
export default Vue.extend({
    computed: {
        convoId() {
            return this.$vstore.settings.state.preferenceSettings.guid;
        },
        channelId() {
            return this.$vstore.settings.state.preferenceSettings.channelId;
        }
    },
    methods: {
        async onChange(event: any) {
            await this.getValidationSettings();
            if (this.convoId && this.channelId && !this.getValidationSettingFailed) {
                this.showFileSizeValidation = false;
                this.showFileTypeValidation = false;
                this.showMaxFilesValidation = false;
                if (this.checkFileinputSize(event)) { //for max files counter
                    for (const file of this.$refs.tactfulFiles.files) {
                        //as there is a callback for pushing in array so we should check again 
                        let fileType = file.type.split('/'); //read file type
                        let fileName = file.name;
                        if (this.validExtension(file.name)) { //validate file size
                            if (file.size <= this.maxFileSize) {
                                this.addFileReader(file, fileType, fileName);
                            } else {
                                this.showFileSizeValidation = true;
                                this.setTimeIntervalForFileSizeValidation();
                            }
                        } else {
                            this.addFileextionsToAlert(file.name);
                            this.showFileTypeValidation = true;
                            this.setTimeIntervalForFileTypeValidation();
                        }
                    }
                } else {
                    this.showMaxFilesValidation = true;
                    this.setTimeIntervalForMaxFilesValidation();
                }
                //start uploading in api for cloud
                await this.startToUploadFiles();
                this.$refs.tactfulFiles.value = "";
            }

        },
        addFileextionsToAlert(file: string) {
            this.fileIsNotSupported = "";
            let patternFileExtension: any = (/[.]/.exec(file)) ? /[^.]+$/.exec(file) : [];
            if (patternFileExtension.length > 0) {
                this.fileIsNotSupported = patternFileExtension[0];
            }
        },
        checkFileinputSize(event: any) {
            //the user may dragging file OR open file browse direct
            if (event.dataTransfer) {
                return this.files.length + event.dataTransfer.files.length <= this.maxFilesToUpload;
            } else if (event.target) {
                return this.files.length + event.target.files.length <= this.maxFilesToUpload;
            }
        },
        addFileReader(file: any, fileType: string, fileName: string) {
            let oFReader = new FileReader();
            oFReader.onload = (e) => { //prepear image thumbnail
                this.files.push({
                    type: fileType[0],
                    originalType: file.type,
                    name: fileName,
                    file: file,
                    src: e.target.result,
                    size: (file.size / (1024 * 1024)).toFixed(2),
                    originalSize: file.size,
                    status: 'uploading',
                    id: null,
                    fileExtension: fileType[1] || null
                });
            };
            oFReader.readAsDataURL(file);
        },
        dragover(event: any) {
            event.preventDefault();
            this.dragInProgress = true;

        },
        dragleave(event: any) {
            event.preventDefault();
            this.dragInProgress = false;
        },
        drop(event: any) {
            event.preventDefault();
            this.dragInProgress = false;
            this.$refs.tactfulFiles.files = event.dataTransfer.files;
            this.onChange(event);

        },
        async removeItem(itemIndex: number, fileId: string) {
            await this.removeAttachmentFromCloud(itemIndex, fileId);
        },
        async removeAttachmentFromCloud(index: number, attachmentId: string) {
            if (attachmentId) {
                this.removeFromReadyToUpload(index, attachmentId);
                try {
                    await window.botClient.deleteAttachment(
                        attachmentId
                    );
                } catch (error) {
                    console.error(error);
                    bugsnagClient.notify(error as any);
                }
            } else {
                this.removeFromReadyToUpload(index, attachmentId);
            }
        },
        removeFromReadyToUpload(index: number) {
            this.files.splice(index, 1);
            this.$vstore.Attachments.state.attachmentsReadyToSend = this.files;
            this.cleanInput();
        },
        cleanInput() {
            if (this.files.length === 0 && this.$refs.tactfulFiles) {
                this.$refs.tactfulFiles.value = "";
            }
        },
        validExtension(fileName: string) {
            let loweredCaseFileName = fileName ? fileName.toLowerCase() : '';
            return (new RegExp('(' + this.fileInputAccept.join('|').replace(/\./g, '\\.') + ')$')).test(loweredCaseFileName);
        },
        setTimeIntervalForFileSizeValidation() {
            this.cleanInput();
            setTimeout(() => {
                this.showFileSizeValidation = false;
            }, showValidationErrorTimer);
        },
        setTimeIntervalForFileTypeValidation() {
            this.cleanInput();
            setTimeout(() => {
                this.showFileTypeValidation = false;
            }, showValidationErrorTimer);
        },
        setTimeIntervalForMaxFilesValidation() {
            this.cleanInput();
            setTimeout(() => {
                this.showMaxFilesValidation = false;
            }, showValidationErrorTimer);
        },
        setTimeShowUploadError() {
            this.cleanInput();
            setTimeout(() => {
                this.showUploadFilesError = false;
            }, showValidationErrorTimer);
        },
        getFormData(object: any) {
            let formData = new FormData();
            let file = object;

            formData.append("file", file, file.name);
            if (this.convoId && this.channelId) {
                formData.append("role", "customer");
                formData.append("channel_id", this.channelId);
                formData.append("conversation_id", this.convoId);
                formData.append("customer_id", storage.get('customerId'));
            }
            return formData;
        },
        async startToUploadFiles() {
            this.$vstore.Attachments.state.uploadingAttachmentsInProgress = true;//to stop any action depend on uploading until uploading finish 

            setTimeout(async () => {//in some cases user after dropping files during uploading would drop another files while uploading working
                //so we need to make some wait time 
                if (this.files.length > 0) {
                    //we want to make array of calling api to upload files
                    //se we use .reduce as it take first parameter as a result of the previous iteration (as a callback)
                    //to make sure the previous call of api finished 
                    //reference >> https://css-tricks.com/why-using-reduce-to-sequentially-resolve-promises-works/
                    await this.files.reduce(async (previousValue: any, item: any, index: number) => {
                        await previousValue;
                        await this.uploadNewAttachment(item, index);
                    }, Promise.resolve());//to make all api calls wait inside loop then continue in working  
                }
                this.$vstore.Attachments.state.uploadingAttachmentsInProgress = false;
                this.removeFailedFiles();
                this.setTimeShowUploadError();
            }, 2000);
        },
        async uploadNewAttachment(item: any, index: number) {
            //user may add another attachment during upload so we need to make sure we don't dublicate upload
            try {
                if (item.status !== 'done') {
                    let formData = this.getFormData(item.file);
                    let response = await window.botClient.uploadtAttachment(formData);
                    if (response && response[0].id) {
                        this.addNewAttchmentsAttributes(index, item, response[0]);
                    } else {
                        this.handleUploadingFail(index);
                    }
                }

            } catch (error) {
                console.error("uploadNewAttachment()", error);
                bugsnagClient.notify(error as any);
                this.handleUploadingFail(index);
            }
        },
        handleUploadingFail(index: number) {
            this.files[index].status = "error";
            this.showUploadFilesError = true;
        },
        removeFailedFiles() {
            let filteredFiles = this.files.filter((item: any) => item.status !== "error");
            this.files = filteredFiles;
            this.$vstore.Attachments.state.attachmentsReadyToSend = filteredFiles;
        },
        addNewAttchmentsAttributes(index: number, attachmentItem: any, response: any) {
            this.files.splice(index, 1, {
                ...attachmentItem,
                status: 'done',
                id: response.id,
                type: this.getFileMainType(response.file_type)
            });
            this.$vstore.Attachments.state.attachmentsReadyToSend = this.files;
        },
        getFileMainType(type: string) {
            if (type && type.includes('/')) {
                let fileType = type.split('/');
                return fileType[0];
            }
            return type;
        },
        handleAttachmentsAfterSend() {
            // clear in sucess 
            this.files = [];
            this.$refs.tactfulFiles.value = "";
            this.$vstore.Attachments.state.attachmentsReadyToSend = [];
        },
        dismissAlert() {
            this.cleanInput();
            this.showFileSizeValidation = false;
            this.showFileTypeValidation = false;
            this.showMaxFilesValidation = false;
            this.showUploadFilesError = false;
        },
        async getValidationSettings() {
            this.getValidationSettingFailed = false;
            if (this.fileInputAccept == null && this.maxFileSize == null) { //to prevent many calls for api
                try {
                    let res = await window.botClient.getAttachmentSettings();
                    if (res && Object.keys(res).length > 0) {
                        this.assignValidationSettings(res);
                    } else {
                        this.getValidationSettingFailed = true;
                    }
                } catch (error) {
                    //if there is any error in getting attachments settings we should stop the upload cycle from the begining  
                    this.getValidationSettingFailed = true;
                    this.showUploadFilesError = true;
                    this.setTimeShowUploadError();
                    bugsnagClient.notify(error as any);
                }
            }
        },
        assignValidationSettings(settings: any) {
            if (settings.extenstions_whitelist) {
                let extenstions = settings.extenstions_whitelist.replace(/[\[\]']+/g, '').replace(/['"]+/g, ''); //first .replace to remove array brackets second for " or '
                this.fileInputAccept = extenstions.split(",");
                this.fileInputAccept = this.fileInputAccept.map((item: any) => '.' + item);
            }
            if (settings.extenstions_whitelist) {
                this.maxFileSize = settings.file_size_limit;
            }
        }
    }
});
